//basic
import React, { Component } from 'react';
import { toJS } from 'mobx';
import { observer, inject } from 'mobx-react';



import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { mdiDotsVertical, mdiArrowDown,mdiCloudUpload, mdiCloudDownload, mdiCart,mdiPencil } from '@mdi/js'
import Checkbox from '@material-ui/core/Checkbox'


//style


//api
// import { api } from '../../functions/api';

//custom components
// import CustomTable3 from '../../components/complex/CustomTable3/CustomTable3';
// import Search from '../../../components/basic/search';
// import CustomButton from '../../../components/basic/CustomButton';



//material-ui
import { CircularProgress, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';

//other libraries
import queryString from 'query-string';
import Icon from '@mdi/react';
import { mdiPlus } from '@mdi/js';
import IconButton from '@material-ui/core/IconButton';
import CustomIconButton from '../../basic/customIconButton'



@observer
export default class TableBodyRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingPage: true,
            addEditDialog: false,
        }
    }
componentDidMount() {
    
}


    render () {

        // title = {}

        return (                                                                                                                                                 
                <TableRow>              
                    <TableCell>                                      
                            <CustomIconButton
                                    // id={this.props.item.id}
                                    // label="More"
                                    dropdownMenu
                                    items={this.props.dropDownMenuItems}
                                    // module={this.props.module}
                                    data={this.props.item}
                                >
                                <Icon path={mdiDotsVertical} size={1} /> 
                            </CustomIconButton>
                        </TableCell>   
                        {/* {this.props.BodyValue.map((item,index) => (
                            <TableCell key={index}>                                                                            
                                    {this.props.item[item.title]}
                            </TableCell> ))}  */}
                        {this.props.data.map((item,index) => (
                            <TableCell key={index}>                                                                            
                                    {item}
                    </TableCell> ))}
                </TableRow>                                      
     )
    }
}


// WEBPACK FOOTER //
// ./src/components/basic/TableRow/TableBodyRow.jsx